module.exports = __webpack_public_path__ + "img/49ne.ebe3c6d4.svg";